import moment from 'moment';
import * as ivsServices from '@/services/ivsServices';
import * as liveServices from '@/services/liveServices';
import * as userServices from '@/services/userServices';
import * as storageServices from '@/services/storageServices';

export default {
  async startNewLiveStreaming({ commit }, payload) {
    const thumbnailPath = `lives/${payload.userId}/thumbnails/${payload.thumbnailFile.name}`;
    const thumbnailUrl = await storageServices.uploadPhoto(
      thumbnailPath,
      payload.thumbnailFile
    );

    const liveDoc = {
      userId: payload.userId,
      title: payload.title,
      aboutLive: payload.aboutLive,
      thumbnailUrl: thumbnailUrl,
      playbackUrl: payload.playbackUrl,
      startAt: moment().toDate()
    };

    const recentLiveDoc = await liveServices.createRecentLive(liveDoc);
    await userServices.updateUserDoc(payload.userId, {
      isStreaming: true,
      recentLiveId: recentLiveDoc.id,
      updatedAt: moment().toDate()
    });

    // TODO: create comment realtime database
    commit('live/updateRecentLive', liveDoc);
    commit('user/updateRecentLiveId', recentLiveDoc.id);
    commit('user/updateIsStreaming', true);
  },
  async startLiveStreaming({ commit }, payload) {
    // update user document
    await userServices.updateUserDoc(payload.userId, {
      isStreaming: true,
      recentLiveId: payload.liveId,
      updatedAt: moment().toDate()
    });

    // update recent live document
    await liveServices.updateRecentLiveByLiveId(
      payload.liveId,
      payload.liveDoc
    );

    // delete upcoming live document
    await liveServices.deleteUpComingLiveByLiveId(payload.liveId);

    // TODO: create comment realtime database
    // commit new state
    commit('live/updateUpComingLive', {});
    commit('live/updateRecentLive', payload.liveDoc);
    commit('user/updateRecentLiveId', payload.liveId);
    commit('user/updateIsStreaming', true);
  },
  async endStreaming({ commit }, payload) {
    // update user document
    await userServices.updateUserDoc(payload.userId, {
      isStreaming: false,
      recentLiveId: '',
      updatedAt: moment().toDate()
    });

    // update ended live document
    const liveDoc = payload.liveDoc;
    delete liveDoc.playbackUrl;
    liveDoc['endedAt'] = moment().toDate();
    await liveServices.updateEndedLiveByLiveId(payload.liveId, liveDoc);

    // delete recent live document
    await liveServices.deleteRecentLiveByLiveId(payload.liveId);

    // commit new state
    commit('live/updateRecentLive', {});
    commit('user/updateRecentLiveId', '');
    commit('user/updateIsStreaming', false);
  },
  async resetStreamKey({ commit }, payload) {
    const { streamKey } = await ivsServices.resetStreamKey(
      payload.channelArn,
      payload.streamKeyArn
    );

    await userServices.updateUserDoc(payload.userId, {
      ivsStreamKeyArn: streamKey.arn
    });
    commit('ivs/updateStreamKey', streamKey);
    commit('user/updateIvsStreamKeyArn', streamKey.arn);
  }
};
